import { BadgePercent } from "lucide-react";
import { PAY_LATER_URL, BALBOA_URL } from "@/data/site";

export const FinancingCallout = ({ variant = "residential" }) => {
  const isCommercial = variant === "commercial";
  return (
    <div data-testid={`financing-callout-${variant}`}
      className="bg-brand-subtle border-l-4 border-brand rounded-sm px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
      <BadgePercent className="w-6 h-6 text-brand shrink-0" />
      <p className="text-sm text-brand-ink leading-relaxed flex-1">
        <span className="font-heading font-bold">Financing available — apply online in minutes.</span>{" "}
        {isCommercial
          ? "Commercial projects can be financed up to $500,000 through Balboa Capital. No site visit required to apply."
          : "Spread the cost of your AC service or replacement with PayPal Pay Later. No site visit required to apply."}
      </p>
      <a
        href={isCommercial ? BALBOA_URL : PAY_LATER_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`financing-callout-${variant}-link`}
        className="shrink-0 text-sm font-bold text-brand hover:text-brand-dark underline underline-offset-4 transition-colors duration-200">
        {isCommercial ? "Apply with Balboa Capital" : "Apply with PayPal Pay Later"}
      </a>
    </div>
  );
};
